/* eslint-disable no-magic-numbers */
import L from "leaflet";
import { createOverlay } from "./overlay.js";

const attributionKartverket =
  '<a href="https://www.kartverket.no/">Kartverket</a>';
const subdomainsKartverket = ["opencache", "opencache2", "opencache3"];
const attributionNVE = '<a href="https://www.nve.no/">NVE</a>';

const Papirkart = L.tileLayer(
  "https://cache.kartverket.no/v1/wmts/1.0.0/toporaster/default/webmercator/{z}/{y}/{x}.png",
  {
    attribution: attributionKartverket,
    subdomains: subdomainsKartverket,
  }
);

const Datakart = L.tileLayer(
  "https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png",
  {
    attribution: attributionKartverket,
    subdomains: subdomainsKartverket,
  }
);

const MTBMap = L.tileLayer(
  "https://mtbmap.no/tiles/osm/mtbmap/{z}/{x}/{y}.jpg",
  {
    minZoom: 5,
    maxZoom: 15,
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> | ' +
      attributionKartverket +
      ' | &copy; <a href="https://mtbmap.no/info">mtbmap.no</a>',
  }
);

const Utløp = L.tileLayer(
  "https://{s}.nve.no/arcgis/rest/services/wmts/Bratthet_med_utlop_2024/MapServer/tile/{z}/{y}/{x}",
  {
    layers: [0, 1, 2, 3],
    subdomains: ["gis2", "gis3", "gis4"],
    attribution: attributionNVE,
  }
);

const Helning = L.tileLayer.wms(
  "https://kart.nve.no/enterprise/services/Bratthet/MapServer/WMSServer",
  {
    layers: "Bratthet_snoskred",
    format: "image/png",
    transparent: "true",
    attribution: attributionNVE,
  }
);

const baseMaps = {
  Papirkart,
  Datakart,
  MTBMap,
};

const overlayMaps = {
  Helning: createOverlay(Helning),
  Utløp: createOverlay(Utløp),
};

const groupedOverlays = {
  Tillegg: overlayMaps,
};

export { groupedOverlays, overlayMaps, baseMaps };
